const version = window.OC?.config?.version?.split(".")[0] || "32";
const isLegacy32 = Number.parseInt(version) < 32;
export {
  isLegacy32 as i
};
//# sourceMappingURL=legacy-MK4GvP26.mjs.map
